module.exports = __webpack_public_path__ + "img/13.61505b87.svg";